import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
  { label: "搜索", to: "/search" },
];

const aboutLinks = [
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
  { label: "华语科幻新势力", to: "/special/s1" },
  { label: "悬疑烧脑精选", to: "/special/s2" },
  { label: "治愈系家庭片单", to: "/special/s3" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70 mt-auto">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading font-extrabold text-sm">
                91
              </span>
              <span className="font-heading font-extrabold text-lg text-foreground-950">
                香蕉视频
              </span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed max-w-md">
              91香蕉视频致力于为用户提供丰富的高清影视资源，涵盖电影、电视剧、综艺等多元内容，
              以简洁清晰的分类与流畅的浏览体验，帮助每一位观众快速找到想看的作品。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {[
                { icon: "ri-wechat-line", label: "微信" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-mail-line", label: "邮箱" },
                { icon: "ri-customer-service-2-line", label: "客服" },
              ].map((item) => (
                <span
                  key={item.label}
                  title={item.label}
                  className="w-9 h-9 rounded-md bg-background-200/60 text-foreground-600 flex items-center justify-center hover:text-primary-400 transition-colors cursor-pointer"
                >
                  <i className={`${item.icon} text-lg`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-foreground-950 mb-4 text-sm tracking-wide">
              快捷导航
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-foreground-950 mb-4 text-sm tracking-wide">
              平台与专题
            </h4>
            <ul className="space-y-2.5">
              {aboutLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 91香蕉视频 · 高清影视资源在线观看平台 · 演示站点
          </p>
          <p className="text-xs text-foreground-500">
            本站为演示用途，所有影视信息均为虚构内容，不提供实际播放服务
          </p>
        </div>
      </div>
    </footer>
  );
}